// src/components/analytics/AnalyticsFilterBar.js
import React from 'react';
import { CalendarDaysIcon, QueueListIcon, ArrowsRightLeftIcon } from '@heroicons/react/24/outline';

const AnalyticsFilterBar = ({
                                dateRange,
                                setDateRange,
                                selectedProgram,
                                setSelectedProgram,
                                availablePrograms,
                                granularity,
                                setGranularity,
                                availableGranularities,
                            }) => {
    return (
        <div className="bg-white rounded-lg shadow-md p-4 flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0 md:space-x-4 mb-6">
            {/* Date Range Filter */}
            <div className="flex items-center space-x-2 w-full md:w-auto">
                <CalendarDaysIcon className="h-5 w-5 text-gray-500" />
                <label htmlFor="dateRangeFilter" className="sr-only">Date Range</label>
                <select
                    id="dateRangeFilter"
                    value={dateRange}
                    onChange={(e) => setDateRange(e.target.value)}
                    className="px-3 py-2 border border-gray-300 rounded-lg bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:border-transparent w-full"
                >
                    <option>Last 7 Days</option>
                    <option>Last 30 Days</option>
                    <option>This Month</option>
                    <option>Last Month</option>
                    <option>This Quarter</option>
                    <option>This Year</option>
                    <option>Custom Range</option>
                </select>
            </div>

            {/* Loyalty Program Filter */}
            <div className="flex items-center space-x-2 w-full md:w-auto">
                <QueueListIcon className="h-5 w-5 text-gray-500" />
                <label htmlFor="programFilter" className="sr-only">Loyalty Program</label>
                <select
                    id="programFilter"
                    value={selectedProgram}
                    onChange={(e) => setSelectedProgram(e.target.value)}
                    className="px-3 py-2 border border-gray-300 rounded-lg bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:border-transparent w-full"
                >
                    {availablePrograms.map(program => (
                        <option key={program} value={program}>{program}</option>
                    ))}
                </select>
            </div>

            {/* Granularity Filter */}
            <div className="flex items-center space-x-2 w-full md:w-auto">
                <ArrowsRightLeftIcon className="h-5 w-5 text-gray-500" />
                <label htmlFor="granularityFilter" className="sr-only">Granularity</label>
                <select
                    id="granularityFilter"
                    value={granularity}
                    onChange={(e) => setGranularity(e.target.value)}
                    className="px-3 py-2 border border-gray-300 rounded-lg bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:border-transparent w-full"
                >
                    {availableGranularities.map(gran => (
                        <option key={gran} value={gran}>{gran}</option>
                    ))}
                </select>
            </div>
        </div>
    );
};

export default AnalyticsFilterBar;